import { AfterViewChecked, Component, ElementRef, input, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AiChatMessage } from '../../models/ai-chat-message.model';
import { AIMessageBubbleComponent } from '../ai-message-bubble/ai-message-bubble.component';

@Component({
	selector: 'ai-message-list',
	template: `
		<div class="ai-message-list" #scrollEl>
			@for (message of messages(); track message.id) {
				<ai-message-bubble [message]="message" [avatars]="avatars()" [messageStyles]="messageStyles()" />
			}
		</div>
	`,
	styles: `
		:host {
			display: flex;
			flex-direction: column;
			flex: 1 1 auto;
			min-height: 0;
			overflow: hidden;
		}
		.ai-message-list {
			flex: 1 1 auto;
			min-height: 0;
			overflow-y: auto;
			display: flex;
			flex-direction: column;
		}
	`,
	imports: [CommonModule, AIMessageBubbleComponent],
})
export class AIMessageListComponent implements AfterViewChecked {
	messages = input.required<AiChatMessage[]>()
	avatars = input<Record<string, { src: string, style: Record<string, string> }>>()
	messageStyles = input<Record<string, Record<string, string>>>()

	scrollEl = viewChild<ElementRef<HTMLElement>>('scrollEl')

	private lastMessageCount = 0
	private lastLastText = ''

	ngAfterViewChecked() {
		const messages = this.messages()
		const last = messages[messages.length - 1]
		const lastText = (last?.text || '') + (last?.html || '')
		if (messages.length !== this.lastMessageCount || lastText !== this.lastLastText) {
			this.lastMessageCount = messages.length
			this.lastLastText = lastText
			this.scrollToBottom()
		}
	}

	scrollToBottom() {
		const el = this.scrollEl()?.nativeElement
		if (el) el.scrollTop = el.scrollHeight;
	}
}
